import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private http: HttpClient) {
  }

  ServerUrlObj = {};

  loadConfig(): Promise<any> {
    return this.http.get('/assets/ServerUrls.json')
      .toPromise()
      .then(config => {
        this.ServerUrlObj = config;
        return config
      })
      .catch((err) => {
        console.error('Could not load ServerUrls.json', err);
        return Promise.reject(err);
      });
  }


  get ServerUrl(): string {
    return this.ServerUrlObj["ServerUrl"];
  }
  get ServerUrl1(): string {
    return this.ServerUrlObj["ServerUrl1"];
  }
  get ServerUrl2(): string {
    return this.ServerUrlObj["ServerUrl2"];
  }
  get ServerUrl3(): string {
    return this.ServerUrlObj["ServerUrl3"];
  }
  get ServerUrl4(): string {
    return this.ServerUrlObj["ServerUrl4"];
  }
  get ServerUrl5(): string {
    return this.ServerUrlObj["ServerUrl5"];
  }
  get ServerUrl6(): string {
    return this.ServerUrlObj["ServerUrl6"];
  }
  get ServerUrl7(): string {
    return this.ServerUrlObj["ServerUrl7"];
  }
  get ServerUrl8(): string {
    return this.ServerUrlObj["ServerUrl8"];
  }
  get ServerUrl9(): string {
    return this.ServerUrlObj["ServerUrl9"];
  }
  get ServerUrl0(): string {
    return this.ServerUrlObj["ServerUrl10"];
  }
  get ServerUrlThirdParty(): string {
    return this.ServerUrlObj["ServerUrlThirdParty"];
  }
}
